import { Injectable } from '@angular/core';
import { DataViewDataModel } from '@osos/shared/api';
import { DataViewsPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases/factory/factory-base';
import { DataViewsParserV1Service } from '../../parsers/data-views-parser/data-views-parser-v1.service';
import { ParserFactory } from '../../services';

@Injectable()
export class DataViewsFactoryService extends FactoryBase<
  DataViewDataModel,
  DataViewsPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: DataViewsParserV1Service,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }
  createDataModel(presenter: DataViewsPresenterModel): DataViewDataModel {
    const parser = this.getParser(
      DataViewDataModel,
      DataViewsPresenterModel,
      presenter.specificationVersion,
    );
    const result = parser.getDataModel(presenter);

    return result;
  }

  createPresenterModel(model: DataViewDataModel): DataViewsPresenterModel {
    const parser = this.getParser(
      DataViewDataModel,
      DataViewsPresenterModel,
      model.specificationVersion || 1,
    );
    const result = parser.getPresenterModel(model);
    return result;
  }
}
